var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"padding-left":"40px","padding-right":"40px","text-align":"center"},attrs:{"fluid":""}},[_c('article',{staticStyle:{"width":"600px","margin-left":"auto","margin-right":"auto"}},[_c('routes')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }